import * as React from 'react';
import type { GalleryItemViewModel } from '../ViewModel/GalleryItemViewModel.csharp';
import type { GalleryBlockViewModel } from '~/Blocks/GalleryBlock/ViewModel/GalleryBlockViewModel.csharp';
import type { GallerySectionItemProps } from './Components/GallerySection/GallerySection';
import { GallerySection } from './Components/GallerySection/GallerySection';

export const GalleryBlock: React.FC<GalleryBlockViewModel> = props => {
    const { galleryItems, translations, desktopHeightVariant, mobileHeightVariant, colorVariant } = props;

    const mapGalleryItem = (item: GalleryItemViewModel): GallerySectionItemProps => ({
        image: item.image,
        ratio: item.ratio,
        caption: item.image.caption,
    });

    return (
        <GallerySection
            galleryItems={galleryItems.map(mapGalleryItem)}
            translations={translations}
            desktopHeightVariant={desktopHeightVariant}
            mobileHeightVariant={mobileHeightVariant}
            colorVariant={colorVariant}
        />
    );
};
